import React, { useContext, useEffect, useState } from "react";
import { Alert, Table } from "../../layout";
import { Button } from "../../controls";
import { IconButton, Tooltip } from "@mui/material";
import { ClearRounded, EditRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { useTranslation } from "react-i18next";

const Measurement = (props) => {
  const { memberId } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { branch, setLoader } = useContext(AppContext);
  const [tblData, setTblData] = useState([]);
  const [tblHeader, setTblHeader] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    var memberKeys = [{ id: "name", label: t("Name") }];
    var measKeys = [
      { id: "date", label: t("Date") },

      { id: "height", label: t("HeightFeet") },
      { id: "weight", label: t("WeightKG") },
      { id: "actions", label: t("Actions") },
    ];
    !memberId
      ? setTblHeader([...memberKeys, ...measKeys])
      : setTblHeader([...measKeys]);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberId]);

  useEffect(() => {
    setLoader(true);
    if (branch.id) {
      API(endpoints.Meas + actions.GetAllByBranch).getById(branch.id, (res) => {
        res.status === 200 && setTblData([...res.result]);
        setLoader(false);
      });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  useEffect(() => {
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddEdit = (id) => {
    memberId
      ? navigate(`/member_measurement_form/${memberId}`)
      : navigate(`/measurement_form/${id || ""}`);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: t("CfmTitle"),
      subTitle: t("MMDltTitle"),
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: t("DltSuccessTitle"),
              subTitle: res.msg,
            });
            setTblData((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else {
            setAlert({
              isOpen: true,
              type: "warning",
              title: t("Warning"),
              subTitle: res.msg,
            });
          }
        };
        API(endpoints.Meas).Delete(id, onComplete);
      },
    });
  };
  const ActionComp = (props) => (
    <div className="bs-secondary br-8 w-fit">
      <Tooltip title={t("Edit")}>
        <IconButton
          onClick={() => handleAddEdit(props.id)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <EditRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>

      <Tooltip title={t("Delete")}>
        <IconButton
          onClick={() => handleDlt(props.id)}
          size="small"
          color="error"
          className="mr-5 p-5"
        >
          <ClearRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
    </div>
  );

  const HeaderComp = () => (
    <div>
      <Button onClick={() => handleAddEdit()}>{t("AddMeasurement")}</Button>
    </div>
  );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={tblHeader}
        tblData={tblData.map((j) => {
          return {
            ...j,

            name: (
              <span
                className="link"
                onClick={() => navigate(`/view_member_profile/${j.member.id}`)}
              >
                {j.member.firstName + " " + j.member.lastName}
              </span>
            ),
          };
        })}
      />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Measurement;
